import { render } from "./SpecialInstruction.vue?vue&type=template&id=594ae33a&scoped=true"
import script from "./SpecialInstruction.vue?vue&type=script&lang=ts"
export * from "./SpecialInstruction.vue?vue&type=script&lang=ts"

import "./SpecialInstruction.vue?vue&type=style&index=0&id=594ae33a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-594ae33a"

export default script